var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Dialog',{staticClass:"empty-passport-dialog",on:{"closeModal":_vm.close}},[_c('div',{staticClass:"title"},[_vm._v(" No pet ")]),_c('div',{staticClass:"description"},[_vm._v(" The user did not give data about the pet ")]),_c('Button',{staticClass:"button",on:{"click":_vm.close}},[_vm._v("Cancel")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }